import { NextPageContext } from "next";

export async function safeRedirect(location: string, ctx?: NextPageContext) {
  if (ctx?.req) {
    ctx?.res?.writeHead(302, { Location: location });
    ctx?.res?.end();
  }

  document.location.replace(location);
}

export default safeRedirect;
